import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function scrollToElementById(id) {
  if (!id) return;
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

/**
 * After route + DOM settle, scroll to hash target (home sections).
 */
function scheduleHomeHashScroll(hash) {
  if (!hash || hash === '#') return;
  const id = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!id) return;
  const run = () => scrollToElementById(id);
  requestAnimationFrame(() => {
    requestAnimationFrame(run);
  });
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (pathname.startsWith('/portfolio')) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  useEffect(() => {
    if (pathname !== '/') return;
    if (hash) {
      scheduleHomeHashScroll(hash);
    }
  }, [pathname, hash]);

  return null;
}
